'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import styles from './MiniLogo.module.css';

interface MiniLogoProps {
  className?: string;
}

const MiniLogo: React.FC<MiniLogoProps> = ({ className = '' }) => {
  const router = useRouter();

  const handleLogoClick = () => {
    router.push('/landing-page');
  };

  return (
    <div
      className={`${styles.miniLogoContainer} ${className}`}
      onClick={handleLogoClick}
    >
      <Image
        src="/icons/logo-mini.svg"
        alt="PIF Global Series Mini Logo"
        className={styles.miniLogoImage}
        width={129}
        height={32}
      />
    </div>
  );
};

export default MiniLogo;
